import script from "./confirm-success.vue?vue&type=script&setup=true&lang=ts"
export * from "./confirm-success.vue?vue&type=script&setup=true&lang=ts"

import "./confirm-success.vue?vue&type=style&index=0&id=55bf78cc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55bf78cc"]])

export default __exports__